import { RoleResponseDto } from '@tradgine/data-access/auth';
import { Role } from '../domain/role.model';

export function toRole(dto: RoleResponseDto): Role {
    return {
        id: dto.id,
        name: dto.name,
        displayName: dto.displayName,
    };
}
